import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import cdiceimage from '../../assets/images/portfolio_cdice.png';
import CDiceContant from '../other_language/productcard/CRouletteContant';
export default function CDiceCard() {
  return (
    <a href='https://c-dice.info/'>
    <Card>
      <CardActionArea>
        <CardMedia
          component="img"
          height="140"
          image={cdiceimage}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            C-Dice
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <CDiceContant/>
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </a>
  );
}
